import * as React from 'react';
const SvgInfo = (props) => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width={20}
        height={20}
        fill='none'
        {...props}>

        <g>
            <path
                fill='currentColor'
                d='M9.996 13.792a.53.53 0 0 0 .387-.156.52.52 0 0 0 .159-.386V9.542A.527.527 0 0 0 10.004 9a.53.53 0 0 0-.387.156.52.52 0 0 0-.159.386v3.708q0 .23.155.386.154.156.383.156m0-6.051a.58.58 0 0 0 .594-.586.58.58 0 0 0-.585-.594.58.58 0 0 0-.595.586.58.58 0 0 0 .586.594m.011 9.843a7.4 7.4 0 0 1-2.947-.592 7.6 7.6 0 0 1-2.42-1.63 7.7 7.7 0 0 1-1.631-2.418 7.4 7.4 0 0 1-.592-2.952q0-1.57.592-2.943a7.65 7.65 0 0 1 4.048-4.04 7.4 7.4 0 0 1 2.951-.592q1.57 0 2.943.592a7.68 7.68 0 0 1 4.04 4.043 7.4 7.4 0 0 1 .592 2.941 7.4 7.4 0 0 1-.592 2.948 7.65 7.65 0 0 1-4.043 4.05 7.4 7.4 0 0 1-2.94.593M10 16.5q2.709 0 4.604-1.896T16.5 10t-1.896-4.604T10 3.5 5.396 5.396 3.5 10t1.896 4.605Q7.292 16.5 10 16.5'
            />
        </g>
    </svg>
);
export default SvgInfo;
